<template>
  <div class="info">
    <label v-bind:for="id">{{label}}</label>
    <div v-bind:id="id" class="number-button">{{value}}</div>
  </div>
</template>

<script>
export default {
  props: ["id", "label", "value"]
};
</script>

<style scoped>
.number-button {
  float: left;
  display: block;
  width: 100%;
  height: 35px;
  text-align: center;
  font-size: 100%;
  color: #fff;
  background-color: #585858;
  border: 2px solid #000;
  padding: 0.2em;
  line-height: 25px;
}
</style>


